import React, { useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import Search from './search';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import MyAvatar from './myAvatar';
import { ArrowLeftOutlined, SettingOutlined } from '@ant-design/icons';
import { addOpacityMenu } from 'src/utils/colorHelpers';
import { pingAPI } from 'src/actions/maintenanceActions';
import paLogo from 'img/PA_Logo_white.svg';

const useStyles = createUseStyles({
	menu: (props) => ({
		lineHeight: '64px',
		display: 'flex',
		position: 'fixed',
		width: '100%',
		left: '0',
		top: '0',
		right: '0',
		height: '64px',
		zIndex: '1000',
		'& .ant-menu-item': {
			'&:hover': {
				background: `${props.model_TopBack} !important`,
				color: `${props.model_TopText} !important`,
			},
			color: `${addOpacityMenu(props.model_TopText)} !important`,
		},
		'& .ant-menu-item-selected': {
			background: `${props.model_TopBack} !important`,
			color: `${props.model_TopText} !important`,
		},
	}),
	textColor: {
		color: 'inherit !important',
	},
	rightItems: {
		float: 'right',
	},
	leftItems: {
		float: 'left',
	},
	search: {
		display: 'flex !important',
		justifyContent: 'center !important',
		alignItems: 'center !important',
		margin: '0 auto !important',
	},

	connectionStatusSpan: {
		color: 'red',
		animation: '$blinkingText 3s infinite',
	},
	'@keyframes blinkingText': {
		'0%': { color: 'red' },
		'49%': { color: 'red' },
		'60%': { color: 'transparent' },
		'99%': { color: 'transparent' },
		'100%': { color: 'red' },
	},
	connectionStatus: {
		cursor: 'default',
	},
	logo: {
		position: 'relative',
		top: '8px',
	},
	searchSpace: {
		display: 'flex',
		width: '100%',
	},
	space: {
		width: '54.83px',
		height: '100%',
	},
});

const ErrorNavbar = (props) => {
	const { modelList, activeUser, modelView = false, projectView, activeModel, settings, resetError } = props;
	const { user } = activeUser;
	const { model } = activeModel;
	const { homeView, slug } = model;

	const { menuColor: colors } = settings;

	const [apiOnline, setApiOnline] = useState(true);
	const [clientOnline, setClientOnline] = useState(window.navigator.onLine);
	const classes = useStyles(colors);
	const { t } = useTranslation();
	const location = useLocation();

	// ping the api every 30s to know if it is still up
	useEffect(() => {
		const interval = setInterval(() => {
			pingAPI().then((apiState) => {
				setApiOnline(apiState);
				setClientOnline(window.navigator.onLine);
			});
		}, 30000);

		return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
	}, []);

	useEffect(() => {
		setClientOnline(window.navigator.onLine);
	}, []);

	const adminViewLink =
		activeModel.model._id !== '' ? `/adminView/models/${activeModel.model._id}/index` : `/adminView/addModel`;

	const displayConnectionStatus = () => {
		if (clientOnline && apiOnline) {
			return null;
		}
		let connectionStatus = '';
		if (!apiOnline) {
			connectionStatus = t('maintenance.apiOffline', '*API offline!');
		}
		if (!clientOnline) {
			connectionStatus = t('maintenance.clientOffline', '*You are offline!');
		}

		return (
			<Menu.Item className={`${classes.leftItems} ${classes.connectionStatus}`} key='connectionStatus'>
				<span className={classes.connectionStatusSpan}> {connectionStatus}</span>
			</Menu.Item>
		);
	};

	return (
		<Menu style={{ background: colors.model_TopBack }} mode='horizontal' theme='dark' className={classes.menu}>
			<Menu.Item onClick={resetError} className={classes.leftItems} key='/'>
				<Link to='/' className={classes.logo}>
					<img src={paLogo} width='80' alt='Company Logo' />
				</Link>
			</Menu.Item>
			{displayConnectionStatus()}

			{projectView && (
				<Menu.Item onClick={resetError} className={classes.leftItems} key='modelview'>
					<Link
						to={slug !== '' && homeView !== '' ? `/model/${slug}/view/${homeView}` : '/'}
						className={classes.textColor}
					>
						<ArrowLeftOutlined /> {t('adminView.menu.mdlv', 'Model View')}
					</Link>
				</Menu.Item>
			)}

			{modelView || projectView ? (
				<Menu.Item onClick={resetError} className={classes.search} key='navigation-item'>
					<Search />
				</Menu.Item>
			) : (
				<Menu.Item className={classes.search} key='navigation-item'>
					<span />
				</Menu.Item>
			)}

			{activeUser && activeUser.user && activeUser.user.adminAccess && (
				<Menu.Item onClick={resetError} className={classes.rightItems} key='/admin-view/'>
					<Link to={adminViewLink} className={classes.textColor}>
						<SettingOutlined />
						<span>{t('navbar.admin', 'Admin Mode')} </span>
					</Link>
				</Menu.Item>
			)}
			<Menu.Item className={classes.rightItems} key='avatar'>
				{!user || (Object.keys(user).length === 0 && user.constructor === Object) ? (
					<Link onClick={resetError} to={`/login?redirect=${location.pathname}`} className={classes.textColor}>
						<span>{t('navbar.login', 'Login')} </span>
					</Link>
				) : (
					<MyAvatar
						// user name avatar in top right corner
						userId={user._id}
						username={user.name}
						adminAcess={user.adminAccess}
						models={modelList.items}
						resetError={resetError}
					/>
				)}
			</Menu.Item>
		</Menu>
	);
};

const mapStateToProps = (state) => ({
	activeUser: state.activeUser,
	modelList: state.modelList,
	activeModel: state.activeModel,
	settings: state.settings,
});

export default connect(mapStateToProps)(ErrorNavbar);
